import { createContext, useContext } from 'react';

export const StepperContext = createContext(null);

export const useStepperContext = () => {
  const ctx = useContext(StepperContext);
  if (ctx === null) {
    throw new Error('useStepperContext must be used inside the Stepper layout');
  }
  return ctx;
};
